module.exports = __webpack_public_path__ + "fonts/no-notifications.svg";